import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import {
  faPhonePlus,
  faSearchLocation,
  faShieldAlt,
} from "@fortawesome/pro-light-svg-icons"

import SmartLink from "../layout/SmartLink/SmartLink"
import Search from "../Search/Search"

import {
  bannerImage,
  container,
  info,
  pageHeader,
  searchCard,
  searchContainer,
} from "./styles.module.scss"
import InfoBox from "./InfoBox/InfoBox"
import { MediumAndUp } from "../layout/Responsive/Responsive"
import { InlineText } from "../Typography/Typography"
import StaticImage from "../StaticImage"

const PageHeader = ({
  locationName,
  careType,
  pageType,
  currentUrl,
  careServiceType,
}) => {
  const images = {
    care_home: {
      name: "banner_carehome",
      objectPosition: "50% 40%",
    },
    home_care: {
      name: "banner_homecare",
      objectPosition: "top",
    },
  }

  return (
    <div className={classNames(pageHeader)}>
      <div className={classNames(container)}>
        <div className={searchContainer}>
          <div className={classNames(searchCard)}>
            <Search
              locationName={locationName}
              careType={careType}
              pageType={pageType}
              currentUrl={currentUrl}
              careServiceType={careServiceType}
            />
          </div>
        </div>
        <StaticImage
          name={images[careType]?.name || "banner_agnostic"}
          className={bannerImage}
          objectPosition={images[careType]?.objectPosition}
          loading="eager"
        />
      </div>
      <MediumAndUp>
        <aside className={classNames(info)}>
          <InfoBox icon={faSearchLocation}>
            <>Search the whole market</>
            <>Compare thousands of UK care providers.</>
          </InfoBox>
          <InfoBox icon={faShieldAlt}>
            <>Quality assured</>
            <>All our care providers are regulated.</>
          </InfoBox>
          <InfoBox icon={faPhonePlus}>
            <>Get expert advice</>
            <>
              <SmartLink to="https://www.caresourcer.com/care-concierge/">
                <InlineText brand>Request a Call Back</InlineText>
              </SmartLink>{" "}
              from one of our care experts
            </>
          </InfoBox>
        </aside>
      </MediumAndUp>
    </div>
  )
}

PageHeader.propTypes = {
  locationName: PropTypes.string,
  careType: PropTypes.oneOf(["home_care", "care_home"]),
  pageType: PropTypes.oneOf(["Filtered Directory", "Location Directory"])
    .isRequired,
  currentUrl: PropTypes.string.isRequired,
  careServiceType: PropTypes.oneOf(["dementia"]),
}

PageHeader.defaultProps = {
  careType: undefined,
  locationName: undefined,
  careServiceType: undefined,
}

export default PageHeader
